// extracted by mini-css-extract-plugin
module.exports = {"vertical-scroll":"VerticalScrollView_vertical-scroll__1GtG0","inner":"VerticalScrollView_inner__1leD-"};